import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NGXLogger } from 'ngx-logger';
import { map, tap } from 'rxjs/operators';

import { PortalMessageBroker } from '../portal/portal-message-broker';

/**
 * Funktionaler Guard, der prüft, ob der Nutzer angemeldet ist.<br>
 * Unterstützt sowohl den Standalone-Login (OIDC/Keycloak mit Auto-Login)
 * als auch den Login über das Portal (dort gilt der Nutzer als angemeldet).
 */
export const authGuard: CanActivateFn = () => {
  const logger = inject(NGXLogger);
  const portalMessageBroker = inject(PortalMessageBroker);
  const oidcSecurityService = inject(OidcSecurityService);

  // INFO: Prüfe, ob im Portal ausgeführt
  if (portalMessageBroker.isRunningInPortal()) {
    logger.trace('authGuard: running in portal: ', true);
    // INFO: Annahme: Benutzer ist angemeldet
    return true;
  }

  // INFO: Prüfe Authentifizierungsstatus über OidcSecurityService
  return oidcSecurityService.isAuthenticated().pipe(
    map((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        logger.trace('authGuard: running in standalone, authenticated: ', true);
        return true;
      }

      // Starte Auto-Login für nicht authentifizierte Benutzer
      logger.trace('authGuard: running in standalone, not authenticated - triggering login');
      oidcSecurityService.authorize();
      return false;
    }),
    tap((canActivate) => {
      logger.trace('authGuard: final canActivate result: ', canActivate);
    }),
  );
};
